// extracted by mini-css-extract-plugin
export default {"root":"NoTariffDialog_root__xGOYo","box":"NoTariffDialog_box__e4gMJ","title":"NoTariffDialog_title__VvvC0","subtitle":"NoTariffDialog_subtitle__xA00Y"};